var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSortListDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.25;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,15c0-0.3,0.1-0.5,0.3-0.7c0.4-0.4,1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-4,4 c-0.4,0.4-1,0.4-1.4,0l-4-4C7.1,15.5,7,15.3,7,15z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,10c0,0.3-0.1,0.5-0.3,0.7c-0.4,0.4-1,0.4-1.4,0L12,7.4l-3.3,3.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l4-4 c0.4-0.4,1-0.4,1.4,0l4,4C16.9,9.5,17,9.7,17,10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortListDesc);
export default __webpack_public_path__ + "static/media/icon-sort-list-desc.588b04a1a5039fc4228915fba3b95a0d.svg";
export { ForwardRef as ReactComponent };